import React from 'react';

import TicketCategorizationContainer from '@totem/components/ticketing/categorizationManagement/TicketCategorizationContainer';
import TicketCategorizationLayout, {
  TicketCategorizationExtra,
} from '@totem/components/ticketing/categorizationManagement/TicketCategorizationLayout';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const TicketCategorizationPage = () => (
  <ContentLayout>
    <TicketCategorizationContainer>
      <IBCard
        isCovered
        title="Ticket Categorization"
        extra={<TicketCategorizationExtra />}
      >
        <TicketCategorizationLayout />
      </IBCard>
    </TicketCategorizationContainer>
  </ContentLayout>
);

export default TicketCategorizationPage;
